import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { omit } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
import { Link } from 'site-modules/shared/components/link/link';
import { srpLinkBuilderWithParamsConversion } from 'site-modules/shared/utils/srp-link-constructor';
import {
  BUY_ONLINE_ACQUISITION_CREATIVE_ID,
  BUY_ONLINE_ACQUISITION_DATA,
} from 'client/site-modules/shared/constants/used-core';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './buy-online-section.scss';

export function BuyOnlineSection({ params, isMobile = false }) {
  const data = BUY_ONLINE_ACQUISITION_DATA;
  const imgSrc = '/img/car-buying/buy-online/buy-online.png';
  const buyOnlineImg = (
    <img
      src={getStaticImageUrl(imgSrc)}
      width={isMobile ? 158 : 228}
      className="d-block mx-0 mx-md-auto mb-1_5 mb-md-0"
      alt="Buy online"
      loading="lazy"
    />
  );

  return (
    <div
      className={classNames('d-flex justify-content-between buy-online-acquisition', {
        'flex-column': isMobile,
      })}
    >
      {isMobile && buyOnlineImg}
      <div>
        <h3 className="heading-3 mb-1_5">{data.header}</h3>
        {data.items && (
          <ul className="ps-1_5 text-start text-gray-darker" style={{ marginBottom: '24px' }}>
            {data.items.map((item, index) => (
              <li key={`copy_${index + 1}`}>{item}</li>
            ))}
          </ul>
        )}
        {data.copy && <div className="mb-1 mb-md-1_5 text-gray-darker copy">{data.copy}</div>}
        <div>
          <Button
            tag={Link}
            to={srpLinkBuilderWithParamsConversion(omit(params, 'year'), true)}
            rel="nofollow"
            data-tracking-id="view_search_result_online"
            size="lg"
            className="px-1 py-0_5 size-16 text-white text-transform-none fw-medium bg-primary-darker"
            data-tracking-parent={BUY_ONLINE_ACQUISITION_CREATIVE_ID}
          >
            Search Cars to Buy Online
          </Button>
        </div>
      </div>
      {!isMobile && (
        <div className="align-self-center" style={{ marginRight: '56px' }}>
          {buyOnlineImg}
        </div>
      )}
    </div>
  );
}

BuyOnlineSection.propTypes = {
  params: PropTypes.shape({}).isRequired,
  isMobile: PropTypes.bool,
};
